import Axios from 'axios'
import store from '../store'
import strings from '@/strings'
import utils from '@/utils/utils.js'

const desk = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getWebapigwUrl() {
    return process.env.VUE_APP_URL_SERVER_BASE
  },
  getAvailableDesks(locationId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/desks/names`)
  },
  getInviteInformationsToBook(inviteId) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/invites/${inviteId}`)
  },
  findAvailableDesksForManager(siteId, locationId, start, finish, email) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/sites/${siteId}/locations/${locationId}/desks/booking?Start=${start}&Finish=${finish}&Email=${email}`)
  },
  getDesksByRegion(regionId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/regions/${regionId}/desks`)
  },
  relateDesksToRegion(relation) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/regions/${relation.regionId}/desks`, relation.desks)
  },
  findAvailableDesksForTeam(payload) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/sites/${payload.siteId}/locations/${payload.locationId}/desk-bookings-status?start=${payload.start}&finish=${payload.finish}`)
  },
  findAvailableDesksAndZones(payload) {
    const queryParams = utils.generateQueryString({ dates: payload.dates, startPeriod: payload.start, endPeriod: payload.finish }, false)
    return Axios.get(`${this.getWebapigwUrl()}/api/v1/clients/${this.getClientId()}/sites/${payload.siteId}/locations/${payload.locationId}/space-occupancies/desk-bookings`, queryParams, {
      ignoreGlobalCatch: true,
    })
  },
  getDeskWithLocation() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desks/names`)
  },
  getDesks(locationId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/desks`)
  },
  getDesksQrCodesFile(filters) {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(
      `api/${strings.apiVersion.admin}/clients/${filters.clientId}/sites/${filters.siteId}/locations/${filters.locationId}/desks/qrcodes/file`, headers)
  },
  getLocationsGroupedBySite() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desks/sites`)
  }
}

export default desk
